import React from 'react';
import { StyleSheet, View } from 'react-native';
import FastImage from 'utils/packages/rnFastImage';
import { AppView, Button, Spacer, rem } from 'design-system';
import BottomPanel from 'design-system/BottomPanel';
import StatusBar from 'design-system/StatusBar';
import { tierThemes } from 'features/premium/benefits';
import { useHeaderHeight } from 'hooks';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import Pricing from './Pricing';
const strings = {
    noThanks: 'No, thanks',
};
const PromotionWithPresentLayout = ({ formattedPrices, subscription, isFetching, positiveButtonText, onPressDecline, onPressPurchase, }) => {
    const headerHeight = useHeaderHeight();
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    return (<AppView type="primary" withFrame={false}>
      <View style={[styles.mainContainer, paddingHorizontalStyle]}>
        <StatusBar barStyle="dark-content" animated/>
        <FastImage source={require('../img/gifts.png')} resizeMode="cover" style={styles.giftImage}/>
        <View style={styles.mainContainer}>
          <View style={[
            {
                paddingTop: headerHeight,
            },
            styles.textContainer,
        ]}>
            <Pricing title={`What about a ${formattedPrices.percentOff}%\ndiscount on ${tierThemes[subscription.tier].name}?`} formattedPrices={formattedPrices} period={subscription.period} tier={subscription.tier}/>
          </View>
        </View>
      </View>
      <BottomPanel style={styles.bottomPanel}>
        <Button brandReversed title={strings.noThanks} onPress={onPressDecline} testID="cancelButton"/>
        <Spacer.H8 />
        <Button title={positiveButtonText} preventDoubleTap brand onPress={onPressPurchase} isFetching={isFetching} testID="purchaseButton"/>
      </BottomPanel>
    </AppView>);
};
const IMAGE_SIZE = 503;
const styles = StyleSheet.create({
    giftImage: {
        position: 'absolute',
        bottom: 30,
        height: rem(IMAGE_SIZE),
        width: '100%',
        alignSelf: 'center',
    },
    textContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        paddingBottom: rem(IMAGE_SIZE),
    },
    mainContainer: {
        flex: 1,
    },
    bottomPanel: {
        ...StyleSheet.absoluteFillObject,
        top: undefined,
    },
});
export default PromotionWithPresentLayout;
